import { memo, useState } from 'react';
import CommandPaletteDialog from './CommandPaletteDialog';

/**
 * Command palette with dialog only (no provider)
 */
function CommandPalette() {
    const [isOpen, setIsOpen] = useState(false);

    return <CommandPaletteDialog isOpen={isOpen} setIsOpen={setIsOpen} />;
}

export default memo(CommandPalette);

